"use client";

export { default } from "@/components/shared/RouteError";
